import { AdminDisableUserResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../../../../../services/core-api-service";

class DisableUserDialogService {
    public async disableUser(userId: string): Promise<AdminDisableUserResult> {
        return api.admin.disableUser(userId, {})
    }
}

export const service = new DisableUserDialogService()